import { useState, useEffect, useRef } from "react";
import Image from "next/image";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { submitCommentInChat } from "../../../../../redux/actions/chat.actions";
import { ConditionName } from "../../../../../interfaces";
import { conditions } from "../../../../../helpers";
import IMAGES from "../../../../../images/importImages";
import { setChatEmojisPopover } from "../../../../../redux/slices/popoversSlice";
import { getLoginZarebinUrl } from "../../../../../services";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const EmojiPicker = dynamic(() => import("../emojiPicker/emojiPicker"));

const defaultTexts = [
    {
        text: "سلام",
        sticker: "👋",
    },
    {
        text: "خیلی عالی",
        sticker: "👍",
    },
    {
        text: "آفرین",
        sticker: "👏"
    },
    {
        text: "خدا قوت",
        sticker: "🙏",
    },
]

const AddChatComment = () => {

    const [inputValue, setInputValue] = useState<string>("");
    const [selectedEmoji, setSelectedEmoji] = useState<string>("");
    const [chatSlideArrow, setchatSlideArrow] = useState<boolean>(false);
    const [chatSlideScrollLeft, setchatSlideScrollLeft] = useState<number>(0);

    const inputValueRef = useRef<string>(inputValue);
    const selectedEmojiRef = useRef<string>(selectedEmoji);
    const chatContainerRef = useRef<any>();

    useEffect(() => {
        inputValueRef.current = inputValue;
    }, [inputValue])

    useEffect(() => {
        selectedEmojiRef.current = selectedEmoji;
    }, [selectedEmoji])

    const dispatch = useAppDispatch();
    const { chatEmojisPopover } = useAppSelector(({ popovers: { chatEmojisPopover } }) => ({ chatEmojisPopover }), shallowEqual);
    const { socket } = useAppSelector(({ chats: { socket, chatEnabled } }) => ({ socket, chatEnabled }), shallowEqual);
    useAppSelector(({ videoData: { isComplexDesktop, isComplexPortrait } }) => ({ isComplexDesktop, isComplexPortrait }), shallowEqual);
    useAppSelector(({ user: { isLogin } }) => ({ isLogin }), shallowEqual);

    useEffect(() => {
        if (selectedEmoji) {
            setInputValue(`${inputValue}${selectedEmoji}`);
            setSelectedEmoji("");
        }
    }, [selectedEmoji])

    useEffect(() => {
        const handleSendCommentInputKeyPress = (event: any) => {
            if (event.key === "Enter" && event.target.id === "send-chat-input" && (!!inputValueRef.current || !!selectedEmoji)) submitCommentInChat(inputValueRef.current,setInputValue);
        }
        document.addEventListener("keypress", handleSendCommentInputKeyPress);
        return () => document.removeEventListener("keypress", handleSendCommentInputKeyPress);
    }, [])

    const handleNextChat = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        chatContainerRef.current.scrollLeft -= chatContainerRef.current.clientWidth;
    }

    const handlePrevChat = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        chatContainerRef.current.scrollLeft += chatContainerRef.current.clientWidth;
    }

    useEffect(() => {
        if (chatContainerRef.current) {
            const clientWidth = chatContainerRef.current.clientWidth;
            const scrollWidth = chatContainerRef.current.scrollWidth;
            setchatSlideArrow(scrollWidth > clientWidth);
            setchatSlideScrollLeft(chatContainerRef.current.scrollLeft);
            chatContainerRef.current.addEventListener('scroll', (e: any) => setchatSlideScrollLeft(e.target.scrollLeft));
        }
        return () => chatContainerRef.current && chatContainerRef.current.removeEventListener('scroll', () => true);

    }, [chatContainerRef.current, socket]);

    return (
        <div className={`${conditions(ConditionName.isComplexPortrait) ? "pl-absolute pl-bottom-0" : "pl-relative"} pl-flex-none pl-w-full pl-flex pl-flex-col pl-justify-end`}>
            <div className={`pl-bg-secondary-200 dark:pl-bg-dark-3 pl-border-t ${conditions(ConditionName.isComplexPortrait) ? "pl-border-z-secondary" : " pl-border-z-secondary-100"} dark:pl-border-z-secondary-600 pl-px-4 pl-py-3 pl-flex pl-items-center pl-gap-4 pl-relative pl-z-10`}>
                {conditions(ConditionName.isLogin) ? (
                    <>
                        {conditions(ConditionName.chatEnabled) ? (
                            <div className="pl-relative pl-flex pl-flex-col pl-w-full pl-gap-2">
                                <div className="pl-flex pl-items-center pl-gap-2 pl-overflow-auto no-scrollbar" ref={chatContainerRef}>
                                    {
                                        chatSlideArrow && !conditions(ConditionName.isTouchScreen) && (
                                            <>
                                                {
                                                    chatSlideScrollLeft < 0 && (
                                                        <div className={`pl-flex pl-items-center pl-justify-center pl-cursor-pointer pl-transition hover:pl-scale-[1.2] pl-drop-shadow-lg pl-absolute pl-right-0 pl-rounded-full`} onClick={handlePrevChat}>
                                                            <Image src={IMAGES.chevronCircleRight} width={18} height={18} alt="chevronCircleRight-icon" />
                                                        </div>
                                                    )
                                                }
                                                {
                                                    Math.abs(Math.floor(Math.abs(chatSlideScrollLeft)) + chatContainerRef.current.clientWidth) !== chatContainerRef.current.scrollWidth - 1 && (
                                                        <div className={`pl-flex pl-items-center pl-justify-center pl-cursor-pointer pl-transition hover:pl-scale-[1.2] -pl-rotate-180 pl-drop-shadow-lg pl-absolute pl-left-0 pl-rounded-full`} onClick={handleNextChat}>
                                                            <Image src={IMAGES.chevronCircleRight} width={18} height={18} alt="chevronCircleRight-icon" />
                                                        </div>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    {defaultTexts.map((item:{text:string, sticker:string}, index) => (
                                        <div key={index} className="pl-flex pl-items-center pl-gap-2 pl-bg-gray-highLight dark:pl-bg-z-gray-500 pl-rounded-[16px] pl-px-4 pl-py-1 pl-cursor-pointer" onClick={() => submitCommentInChat(`${item.text} ${item.sticker}`, setInputValue)}>
                                            <p className="pl-text-[12px] pl-font-normal pl-text-gray-800 dark:pl-text-white pl-whitespace-nowrap">{item.text}</p>
                                            <span>{item.sticker}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="pl-flex pl-items-center pl-gap-1">
                                    <div className="pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px]">
                                        <Image alt="emoji-list-icon" src={conditions(ConditionName.isDarkMode) ? (chatEmojisPopover ? IMAGES.emojiHappyWhite : IMAGES.keyboardWhite) : (chatEmojisPopover ? IMAGES.emojiHappyBlack : IMAGES.keyboardBlack)} onClick={() => dispatch(setChatEmojisPopover(!chatEmojisPopover))} className="pl-cursor-pointer" width={24} height={24} />
                                        <input
                                            id="send-chat-input"
                                            className={`pl-text-gray-600 pl-pt-[2px] dark:pl-text-secondary pl-font-normal placeholder:pl-text-gray-600 placeholder:dark:pl-text-secondary pl-w-full pl-bg-transparent pl-outline-none pl-border-none ${conditions(ConditionName.isTouchScreen) ? "pl-text-[12px]" : "pl-text-[14px]"}`}
                                            placeholder="دیدگاه خود را وارد کنید"
                                            onChange={(event: any) => setInputValue(event.target.value)}
                                            maxLength={200}
                                            value={inputValue}
                                        />
                                        <div className="pl-text-[11px] pl-font-normal">
                                            <span>{inputValue.length}</span>
                                            <span>/</span>
                                            <span>200</span>
                                        </div>
                                    </div>
                                    <Image alt="send-comment" src={IMAGES.sendCommentTouchScreen} onClick={() => submitCommentInChat(inputValue, setInputValue)} className="pl-cursor-pointer" width={40} height={40} />
                                </div>
                            </div>
                        ) : <p className="pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px] pl-text-[14px] pl-font-normal pl-text-secondary/[0.7]">در حال حاضر امکان ثبت دیدگاه وجود ندارد.</p>}
                    </>
                ) : <p className="pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px] pl-text-secondary pl-text-[14px] pl-font-normal">شما برای ارسال دیدگاه خود باید {conditions(ConditionName.isZarebinSite) ? <a href={getLoginZarebinUrl()} className="text-primary-600 border-b cursor-pointer border-primary-600">وارد</a> : "وارد"} شوید.</p>}
            </div>
            {chatEmojisPopover && <EmojiPicker enableUnified={false} setSelectedEmoji={setSelectedEmoji} onClickOutside={() => dispatch(setChatEmojisPopover(false))} parentClassName={`pl-bottom-[60px] ${conditions(ConditionName.isComplexDesktop) && "pl-left-[160px]"}`} />}
        </div>
    )
}

export default AddChatComment;